import {configureStore} from "../store";

class Application{
    constructor(){
        this.store = configureStore();
    }
}
export default Application;